import { motion } from 'framer-motion';
import { Marqy } from 'marqy';

import { heroReveal } from '#/lib/hero-reveal';
import type { SanityLogoMarquee } from '#/lib/sanity/queries/logoMarquee';
import { cn } from '#/lib/utils';

export function LogoMarquee(props: SanityLogoMarquee & { className?: string }) {
  return (
    <div
      className={cn(
        {
          'py-50': props.background && props.overline,
          'mb-30 m:mb-50': !props.overline && !props.background,
        },
        props.className,
      )}
      style={{
        background: props.background ?? undefined,
        color: props.foreground ?? undefined,
      }}
    >
      {props.overline ? (
        <motion.h2
          {...heroReveal(0)}
          className="mb-12 text-center m:mb-36 m:text-24 font-[440]  leading-150 tracking-3 m:tracking-5 text-16"
        >
          {props.overline}
        </motion.h2>
      ) : null}
      <motion.div {...heroReveal(1)} className="relative">
        <Marqy>
          <div className="flex items-center gap-x-[var(--gap-x)] pr-[var(--gap-x)] [--gap-x:36px] m:[--gap-x:72px]">
            {props.logos.map((logo) => (
              <div
                key={logo._key}
                style={{
                  maskSize: 'contain',
                  WebkitMaskRepeat: 'no-repeat',
                  maskRepeat: 'no-repeat',
                  maskPosition: 'center',
                  WebkitMaskImage: `url(${logo.url})`,
                  maskImage: `url(${logo.url})`,
                  background: props.foreground ?? undefined,
                  width: logo.logoWidth,
                  height: logo.height * (logo.logoWidth / logo.width),
                }}
              />
            ))}
          </div>
        </Marqy>
        <div
          className="absolute inset-y-0 left-0 w-[10%] m:w-[15%] xl:w-[20%]"
          style={{
            background: `linear-gradient(to right, ${props.background}, ${props.background}00)`,
          }}
        ></div>
        <div
          className="absolute inset-y-0 right-0 w-[10%] m:w-[15%] xl:w-[20%]"
          style={{
            background: `linear-gradient(to left, ${props.background}, ${props.background}00)`,
          }}
        ></div>
      </motion.div>
    </div>
  );
}
